/**
 *
 * RoutingControl
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import withEdit from 'containers/EditService/withEdit';
import withRoute from 'containers/Routes/withEntity';
import DistancePanel from './DistancePanel';
import RoutingGroup from './RoutingGroup';

const Wrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 60px;
  display: flex;
  align-items: flex-start;
  z-index: 650;
  & > * + * {
    margin-left: 5px;
  }
  @media (min-width: 400px) {
    right: 70px;
    & > * + * {
      margin-left: 10px;
    }
  }
  @media print {
    display: none;
  }
`;

/* eslint-disable react/prefer-stateless-function */
function RoutingControl(props) {
  const { workingRoute } = props;
  if (!workingRoute.legs) {
    return null;
  }
  return (
    <Wrapper>
      {workingRoute.legs.length > 0 && (
        <DistancePanel distance={workingRoute.distance} />
      )}
      <RoutingGroup {...props} />
    </Wrapper>
  );
}

RoutingControl.propTypes = {
  workingRoute: PropTypes.object.isRequired,
  createRoute: PropTypes.func.isRequired,
  clearRoute: PropTypes.func.isRequired,
  editRoute: PropTypes.func.isRequired,
  saveRoute: PropTypes.func.isRequired,
  routeId: PropTypes.number,
  routes: PropTypes.object.isRequired,
  undo: PropTypes.func.isRequired,
};

export default compose(
  withEdit,
  withRoute,
)(RoutingControl);
